// extracted by mini-css-extract-plugin
module.exports = {"comp":"Countdown_comp__1xIi0"};